import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'
import { STORE_MAP } from '@/config/cache/cache-engine'

export default {
	getIdentityMounts: {
		cacheStorage: STORE_MAP.FULL,
		apiServiceMethodName: ModulesConfigMap[ModulesMap.IDENTITY_MOUNTS].GET_IDENTITY_MOUNTS,
	},
	getFullIdentityMounts: {
		cacheStorage: STORE_MAP.FULL,
		apiServiceMethodName: ModulesConfigMap[ModulesMap.IDENTITY_MOUNTS].GET_IDENTITY_MOUNTS,
	},
	getBasedIdentityMounts: {
		cacheStorage: STORE_MAP.BASE,
		apiServiceMethodName: ModulesConfigMap[ModulesMap.IDENTITY_MOUNTS].GET_IDENTITY_MOUNTS,
	},
	getExtendedIdentityMounts: {
		cacheStorage: STORE_MAP.EXTENDED,
		apiServiceMethodName: ModulesConfigMap[ModulesMap.IDENTITY_MOUNTS].GET_IDENTITY_MOUNTS,
	},
	getIdentityMount: {
		cacheStorage: STORE_MAP.FULL,
		apiServiceMethodName: ModulesConfigMap[ModulesMap.IDENTITY_MOUNTS].GET_IDENTITY_MOUNT,
	},
	createIdentityMount: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.IDENTITY_MOUNTS].CREATE_IDENTITY_MOUNT,
	},
	patchIdentityMount: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.IDENTITY_MOUNTS].PATCH_IDENTITY_MOUNT,
	},
	deleteIdentityMount: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.IDENTITY_MOUNTS].DELETE_IDENTITY_MOUNT,
	},
}
